export default async function SetupProfileApi(
  firstName,
  lastName,
  imageUrl,
  phone,
  address,
  oldPassword,
  newPassword,
  confirmPassword
) {
  let res = "";
  try {
    const body = {
      firstName: firstName,
      lastName: lastName,
      imageUrl: imageUrl || "",
      phone: phone,
      address: address,
      oldPassword: oldPassword,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/auth/setup-profile`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error creating profile: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
